module.exports = __webpack_public_path__ + "static/img/hetong.e177c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/srmCloud/hetong.png
// module id = 483
// module chunks = 12